module.exports = __webpack_public_path__ + "static/did-you-know-that-bg-a1f5468dd1be64f8c728b370f0e3799c.jpg";